import '@/assets/app.scss'
import { Integrations } from '@sentry/tracing'
import * as Sentry from '@sentry/vue'
import 'animate.css/source/animate.css'
import 'prismjs'
import 'prismjs/themes/prism.css'
import Vue from 'vue'
import App from './App.vue'
import { AxiosPlugin, EventBusPlugin, MomentPlugin, SwalPlugin } from './plugins'
import vuetify from './plugins/vuetify'
import router from './router'
import { AuthGuard } from './router/guard'
import store from './store'

if (process.env.VUE_APP_ENABLE_SENTRY == 'true') {
  console.log('Initialize Sentry')
  Sentry.init({
    Vue,
    dsn: 'https://2b4e532c199f419582d86cda6b7d4ba7@o916782.ingest.sentry.io/5862502',
    integrations: [new Integrations.BrowserTracing()],
  })
}

Vue.config.productionTip = false

// Register plugins

Vue.use(MomentPlugin)
Vue.use(SwalPlugin)
Vue.use(AxiosPlugin)
Vue.use(EventBusPlugin)

const app = {
  router,
  store,
  vuetify,
  render: h => h(App),
}
AuthGuard(app)

new Vue(app).$mount('#app')
